import React, { useState, useEffect} from 'react';
import { NavLink  } from 'react-router-dom';
import DataTable from 'react-data-table-component';
import SweetAlert2 from 'react-sweetalert2';
import { Tooltip } from 'react-tooltip';
import apiService from '../../../Auth/apiService';
import { useAuth } from '../../../Auth/AuthContext';

export default function MovimientoCarpeta(){
    const { token, rol } = useAuth();
    const [Cargando, setCargando] = useState(false);
    const [movimientoCarpetas, setMovimientoCarpetas] = useState([]);
    const [swalProps, setSwalProps] = useState({});
    const columnscarpetas = [
        { name: 'id', selector: row => row.id, sortable: true, width:'5%' },
        { name: 'Identificación', selector: row => row.per_idpersona, sortable: true, width:'10%' },
        { name: 'Nombre', selector: row => row.nombre, sortable: true, width: '15%'},
        { name: 'Fecha prestada', selector: row => row.reg_fechapres.split('T')[0], sortable: true, width: '10%' },
        { name: 'Hora prestada', selector: row => row.reg_horapres, sortable: true, width: '10%' },
        { name: 'Fecha entrega', selector: row => row.reg_fechapres.split('T')[0], sortable: true, width: '10%' },
        { name: 'Hora entrega', selector: row => row.reg_horapres, sortable: true, width: '10%' },
        { name: 'Prestada a', selector: row => row.usr_nombre, sortable: true, width: '15%' },
        { name: 'Observaciones', selector: row => row.reg_observaciones, sortable: true, width: '25%' }
    ];
    useEffect(() => {
        const fetchData = async () => {
            await ConsultarCarpetas();
        };
        fetchData();
    }, []);
    async function ConsultarCarpetas(){
        let url = '/archivo/consultarmovimientocarpetas';
        let obj = {usrRolid: rol }
        try {
            setCargando(true);
            const response = await apiService.post(url, obj, token);
            const result = await response.data;
            setMovimientoCarpetas(result);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setCargando(false);
        }
    }
    return (
        <div className="content-wrapper">
            <section className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                    <div className="col-sm-6">
                        <h1 className="m-0">Movimiento de carpetas</h1>
                    </div>
                    <div className="col-sm-6">
                        <ol className="breadcrumb float-sm-right">
                        <li className="breadcrumb-item"><NavLink to={`/`} >Inicio</NavLink></li>
                        <li className="breadcrumb-item"><NavLink to={`/archivo/0`} >Archivo</NavLink></li>
                        <li className="breadcrumb-item active"> Movimientos</li>
                        </ol>
                    </div>
                    </div>
                </div>
            </section>
            <section className="content">
                <div className="container-fluid">
                      {Cargando && <div className="centered">
                        <div><progress value={null} /></div>
                      </div>}
                </div>
            </section>
            <section className="content">
                <div className="container-fluid">
                    <div className="card-body table-responsive p-0">
                        <DataTable
                            title="Movimientos"
                            columns={columnscarpetas}
                            data={movimientoCarpetas}    
                            progressPending={Cargando}
                            pagination
                            noDataComponent="No hay datos para mostrar"
                        /> 
                    </div>
                </div>{/* /.container-fluid */}
                <SweetAlert2 {...swalProps} 
                didClose={() => {
                    setSwalProps({})
                }}/>
                <Tooltip id="tooltiparriba" effect="solid" className="custom-tooltip" place="bottom"/>
            </section>
        </div>
    );
}